export default __webpack_public_path__ + "static/media/OrangeIndicator.f6164b4a.svg";